export default "__VITE_ASSET__nnrDcv2X__"